import React,{ Fragment, useRef, useState } from 'react';
import {WhiteLinearGradientDarkPlain,} from "../../utils/Utils";
import { Icon } from "@iconify/react";
// import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition, Popover } from '@headlessui/react'
import CustomDialog from "../basic/Dialog";
import ic_close from "../../assets/icons/ic_close.svg";
import IconButton from "../basic/IconButton";
import useIsMobile from "../../utils/useIsMobile";
import {
    createHyperProgram,
    createUserPlaylist,
  } from "../../api/api";


// export function HypoPrograms({ open, close, exercises }){
//     const [ShowNameDialog, setShowNameDialog] = useState(false);
//     const [selectedExercises, setSelectedExercises] = useState([]);
//     // const [routineName, setRoutineName] = useState("");
//     const getExercise = (id) => {
//       let exercise = {};
//       Object.keys(exercises).map((category, categoryIndex) => {
//         exercises[category].forEach((ex) => {
//           if (ex.id === id) {
//             exercise = ex;
//             return exercise;
//           }
//         });
//       });
//       return exercise;
//     };
//     const [expanded, setExpanded] = useState(false);
//     const isMobile = useIsMobile();
//     const createRoutine = async () => {
//       const response = await createHyperProgram(programId);
//       if (response.success) {
//         // const res = await addMultipleExercisesToPlaylist(
//           response.programId,
//           JSON.stringify(selectedExercises)

//         if (response.programId !== " ") {
//           setShowNameDialog(false);
//           toast("Hypo customize program has created", { type: "success" });
//           close();
//         } else {
//           toast("Customize Program Addition failed", { type: "error" });
//         }
//       } else {
//         toast("Error creating hypo customize program", { type: "error" });
//       }
//     };

//     return (
//         <div></div>

//     )

// }

const JoinProgram = ({ open, close, answer, options }) => {
    return (
        <>
            <CustomDialog show={open} close={close}>
                <Dialog.Panel className="bg-[#3C4647] relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <IconButton
            icon={ic_close}
            className="shadow-xl absolute top-0 -right-0"
            onClick={() => {
              close();
            }}
          />
                    <div className="grid grid-rows-2 md:mx-2 mx-1 md:my-6 my-4">
                        <div className="">
                            <p className="text-sm text-primary-neonGreen font-bold">30 days <span className="text-white text-sm">program</span>
                                <br />
                                <p className='text-white font-poppins text-lg font-normal'>About Program
                                    <br />
                                    <p className='text-xs font-extralight my-1'>Here goes the program description, we can put in liners, and more.
                                        <br />
                                        <p className='font-thin mt-2'>Even tools required for the program. Here goes the program description, we can put in liners, and more.</p>
                                        <br />
                                        <p className='font-thin'>Even tools required for the program.</p>
                                    </p>
                                </p>
                            </p>
                        </div>
                        <div className='grid grid-rows-3 mt-2 text-white'>
                            <p className='font-poppins text-md'>Equipments
                                <br />
                                <p className='text-xs font-light mt-0'>Mat, Resistant Band, Bench</p>
                            </p>

                            <p className='font-poppins text-md -mt-1'>Select Difficulty Level
                                <br />
                                <Popover className={"relative w-1/2 md:w-1/3 my-2"}>
                                    <Popover.Button
                                        className={`flex flex-row w-full  space-x-2 text-white border-[1px] border-customGray-700 rounded-lg items-center px-5 py-2`}
                                    >
                                        <p className="text-xl w-full text-left z-0">
                                            {answer
                            ? options.find((element) => element.key == answer).value
                            : "SELECT"}

                                        </p>
                                        <Icon
                                            icon={"akar-icons:chevron-down"}
                                            className="text-[#FFFFFF]"
                                        />
                                    </Popover.Button>
                                    <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-150"
                                        enterFrom="opacity-0 translate-y-0"
                                        enterTo="opacity-100 translate-y-1"
                                        leave="transition ease-in duration-150"
                                        leaveFrom="opacity-100 translate-y-1"
                                        leaveTo="opacity-0 translate-y-0"
                                    >
                                        <Popover.Panel
                                            className={`absolute z-50 w-full -mt-1 p-4 space-y-2 flex flex-col text-[#040405] bg-[#FFFFFF] rounded-xl`}
                                        >
                                            {({ close }) => (
                                                <>
                                                    <p>Easy</p>
                                                    <p>Medium</p>
                                                    <p>Hard</p>
                                                </>
                                            )}
                                        </Popover.Panel>
                                    </Transition>
                                </Popover>
                            </p>
                            <button 
                            className='md:text-xl text-md font-bold md:px-6 md:py-3 rounded-md bg-primary-neonGreen text-[#4A4A4A] font-poppins'
                            onClick={() => {
                                // setShowNameDialog(true);
                              }}
                            >JOIN</button>
                        </div>
                    </div>
                </Dialog.Panel>
            </CustomDialog>
        </>

    );
}

export default JoinProgram;

